module.exports = __webpack_public_path__ + "img/about-footer.950e11c6.png";